<template>
	<modal ref="modal" :title="title" :close_on_focus="false" :no_overflow="true" style="min-width: 455px">
		<div class="form-group row">
			<div class="col-12">
				<label for="form-name">Are you sure you want to delete form: {{ form_name }}?</label>
			</div>
		</div>
		<div class="form-group row">
			<div v-if="!saving" class="col-12 text-right">
				<button class="btn btn-secondary px-2" v-on:click="cancel()">Cancel</button>
				<button class="btn btn-danger px-2 ml-2" v-on:click="remove()">Delete</button>
			</div>
			<loader v-else></loader>
		</div>
	</modal>
</template>

<script>
	import Modal from "../general_components/Modal";
	import Loader from "../general_components/Loader";
	export default {
		name: "DeleteFormModal",
		components: {Loader, Modal},
		props: {
			delete_url: {
				type: String,
				required: true
			}
		},

		data() {
			return {
				form_id: null,
				form_name: null,

				saving: false,
			}
		},

		methods: {
			open(formid, formname) {
					this.form_id = formid;
					this.form_name = formname;

				this.$nextTick(function () {
					this.$refs.modal.openModal();
				})
			},

			cancel() {
				this.$refs.modal.closeModal(null, true);

				this.form_id = null;
				this.form_name = null;
			},

			remove(){
				if (this.saving) return;

				this.saving = true;
                var url = this.delete_url.replace('?', this.form_id);
                console.log(url);
				axios.delete(url, {
					name: this.form_name
				})
					.then(function (response)  {
                        console.log(JSON.stringify(response.data));
						window.location.reload();
					})
					.catch(() => {
                        Vue.$toast.open({
                            message: 'Something went wrong',
                            type: 'error'
                        });
					})
			}
		},

		computed: {
			title(){
				return 'Delete ' + (this.form_name);
			}
		}
	}
</script>
